//imports
import {
    MESSAGE_TEMPLATE_CREATE_EDIT_OPEN_MODAL,
    MESSAGE_TEMPLATE_CREATE_REQUEST,
    MESSAGE_TEMPLATE_CREATE_RESULT,
    MESSAGE_TEMPLATE_EDIT_REQUEST,
    MESSAGE_TEMPLATE_EDIT_RESULT,
    MESSAGE_TEMPLATE_GET_REQUEST,
    MESSAGE_TEMPLATE_GET_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    messageTemplate: null,
    current: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MESSAGE_TEMPLATE_GET_REQUEST:
            return { ...state, loading: true }

        case MESSAGE_TEMPLATE_GET_RESULT:
            return { ...state, loading: false, messageTemplate: action.payload }

        case MESSAGE_TEMPLATE_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, current: action.payload.messageTemplate }

        case MESSAGE_TEMPLATE_CREATE_REQUEST:
            return { ...state, loading: true }

        case MESSAGE_TEMPLATE_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case MESSAGE_TEMPLATE_EDIT_REQUEST:
            return { ...state, loading: true }

        case MESSAGE_TEMPLATE_EDIT_RESULT:
            return { ...state, loading: false, update: action.payload }

        case CLEAR_REDUX:
            return ["", "MESSAGE_TEMPLATE_CREATE_EDIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};